import React, { useState } from "react";
import "./Gallery.css";

// Dynamically import all images
const importAll = (context) => context.keys().map(context);
const imagesArray = importAll(require.context("../../asets/All", false, /\.(jpg|jpeg|png|JPG)$/));

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (imgSrc) => setSelectedImage(imgSrc);
  const closeModal = () => setSelectedImage(null);

  return (
    <div className="gallery-container">
      <h1 className="gallery-title">School Gallery</h1>
      <div className="gallery-grid">
        {imagesArray.map((imgSrc, index) => (
          <div key={index} className="gallery-item" onClick={() => openModal(imgSrc)}>
            <img src={imgSrc} alt={`Gallery ${index + 1}`} className="gallery-img" />
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt="Full View" className="modal-image" />
            <button className="modal-close" onClick={closeModal}>×</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
